import React, { Component } from 'react';
import MyInput from 'components/controls/MyInput';
import Button from 'components/controls/Button';
import _validator from 'modules/validator';
import { routesAdmin } from 'routes/Routes';
import _authService from 'modules/AuthService';
import LoadingSpinner from 'components/enterprise/LoadingSpinner';
import _notification from 'modules/notification';
// Admin Login/Home Page UX Refinement phase: a whitespace-trimmed crop of the same approved
// Universal National Bank Logo (frontend/public/bank-logo.jpg) — not a different logo, the same
// artwork with the excess padding baked into the source PNG removed, so it can sit compactly above
// the heading instead of inside an oversized white rectangle. Referenced the same way PROJECT_LOGO
// itself is (a public/ static path, not a webpack import — public/ assets aren't import-able).
// Scoped to this page's own <img>; no shared branding class/asset was changed.
const ADMIN_LOGIN_LOGO = '../bank-logo-compact.png';

class AdminLogin_new extends Component {
  constructor(props) {
    super(props);
    this.state = {
      adminID: "",
      adminIDState: "",
      password: "",
      passwordState: "",
      passwordError: "",
      isLoginSuccess: "",
      isLoading: false
    };
    this.homePageLink = React.createRef();
  }

  componentDidMount(){
    _authService.clearSessionHist();
    this.getIpAddress();
  }

  getIpAddress = async (ev) => {
    try {
      const response = await _authService.getClientIP();

      if (!response) {
        window.location.href = "/";
      }
    } catch (e) {
      window.location.href = "/";
    }
  }

  onTextChange = ({ target: { name, value } }) => {
    switch (name) {
      case "adminID":
        if (_validator.verifyBlank(value)) {
          this.setState({
            [name + "State"]: "success",
            [name + "Error"]: ""
          });
        } else {
          this.setState({
            [name + "State"]: "error",
            [name + "Error"]: "Invalid Admin User Name"
          });
        }
        break;

      case "password":
        if (_validator.verifyBlank(value)) {
          this.setState({
            [name + "State"]: "success",
            [name + "Error"]: ""
          });
        } else {
          this.setState({
            [name + "State"]: "error",
            [name + "Error"]: "Invalid Password"
          });
        }
        break;

      default:
        this.setState({ [name + "State"]: "success" });
    }
    this.setState({ [name]: value, isLoginSuccess: "" });
  }

  handleLogin = async (ev) => {
    ev.preventDefault();
    if (this.state.adminIDState === "success" && this.state.passwordState === "success" && this.state.adminID.trim() !="" && this.state.password.trim() !="" ) {
      this.setState({ isLoading: true });
      try {
        const response = await _authService.adminLogin({ email: this.state.adminID.trim(), Password: this.state.password.trim() });
        //console.log(response.status);        
        if (response.status == 200 && response.data.Id) {
          _authService.setAdminSessionData(response.data);
          window.setTimeout(() => {
            this.setState({ isLoading: false })
            this.homePageLink.current.click();
          }, 1000);
        }
        else {
          this.setState({ isLoading: false })
          _notification.showMessage('error', response.data.Message);
        }
      } catch (e) {
        console.log("te");
        this.setState({ isLoading: false });
      }
    }
    else {
      if (this.state.adminIDState === "") {
        this.setState({ adminIDState: "error", adminIDError: "Invalid Admin User Name" });
      }
      if (this.state.passwordState === "") {
        this.setState({ passwordState: "error", passwordError: "Invalid Password" });
      }
    }
  }


  render() {
    // Admin Login/Home Page UX Refinement phase — Step 1 (this page only, per that phase's explicit
    // scope boundary; Dashboard/sidebar/other Admin pages deliberately untouched):
    //   - The recruitment-style "National Bank PO Recruitment 2026" header strip is gone (see
    //     PublicHeader.jsx's isAdminLoginPath guard) — this component itself never rendered that
    //     strip; it came from the shared PublicLayout wrapper.
    //   - `.admin-login-wrap`'s grey `--bg-over-color` background is overridden to white, scoped
    //     under `.admin-login-refined` (see themes.scss) so no other `.admin-login-wrap` consumer is
    //     affected — there are none today, but the override stays scoped rather than editing the
    //     shared rule directly, matching this codebase's own established per-page-override pattern.
    //   - Logo swapped from the shared `projectLogoSizeWidth` (200px, sized for contexts with more
    //     vertical room) to a compact, page-scoped size using the whitespace-trimmed logo crop
    //     (ADMIN_LOGIN_LOGO) — removes the "oversized white box" effect without altering the shared
    //     class any other page still relies on.
    //   - Heading corrected from "Welcome to Online User Registration" (leftover candidate-
    //     registration copy, never appropriate for an Admin Login screen) to a concise Admin-specific
    //     heading, per the brief's explicit "Clear, concise Admin Login heading" requirement.
    //   - Vertical spacing tightened throughout (mb-4→mb-3, extra mt-3 removed) so the whole card
    //     comfortably fits a standard desktop viewport with no scroll, without compressing the
    //     inputs/button below a comfortable, readable size.
    return (
      <div className="admin-login admin-login-refined d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
            <form onSubmit={this.handleLogin} className="d-flex ml-3 mr-3 justify-content-center" >
            <div className="gl-bxbr p-4 admin-login-wrap">
                <div className="login-form-wrap position-relative w-100 align-items-center m-auto  form-wrap d-flex align-items-center justify-content-center">
                    <div className="login-form-inner-wrap w-100 d-flex align-items-center justify-items-center flex-column">
                        {/* Quick fix: the "Enter your credentials to access the Admin Portal" subtitle
                            was removed per request. Heading's own bottom margin bumped mb-3→mb-4 (and
                            login-sec's separate mt-3 dropped, since it would otherwise double up with
                            this same gap) so the fields sit at a comfortable, single, intentional
                            distance below "Admin Login" instead of either crowding it or leaving an
                            odd gap where the removed subtitle used to be. */}
                        <img alt='National Bank' src={ADMIN_LOGIN_LOGO} className="admin-login-logo mb-3" />
                        <h3 className="mb-4">Admin Login</h3>

                        <div className="login-sec w-100">
                        <MyInput
                            wrapClass="mt-2"
                            key="adminID"
                            type="text"
                            value={this.state.adminID}
                            name="adminID"
                            onChange={this.onTextChange}
                            placeholder="Admin User Name"
                            heading="Admin User Name"
                            isRequired={false}
                            errorState={this.state.adminIDState}
                            errorMessage={this.state.adminIDError}
                        />
                        <MyInput
                            wrapClass="mt-2"
                            type="password"
                            value={this.state.password}
                            name="password"
                            onChange={this.onTextChange}
                            placeholder="Enter Password"
                            heading="Password"
                            isRequired={false}
                            errorState={this.state.passwordState}
                            errorMessage={this.state.passwordError}
                        />
                        </div>

                        <div className="forget-sec w-100 text-center mt-2">
                        <Button
                            type="submit"
                            className="button-global button-primary mb-3 autoHeight"
                            value="Login"
                        ></Button>
                        </div>
                    </div>
                </div>
            </div>    
            

            <a href={routesAdmin.dashboard.basePath} hidden ref={this.homePageLink} onClick={() => { this.props.history.push(routesAdmin.dashboard.basePath) }}></a>
            {this.state.isLoading && <LoadingSpinner />}
        </form>
      </div>  
      
    );
  }
}

export default AdminLogin_new;